import * as React from 'react'
import { cn } from '@repo/ui/lib/utils'
import { SectionContainer } from '@repo/ui/section'

interface PremiumSectionProps extends React.HTMLAttributes<HTMLElement> {
  containerClassName?: string
}

export const PremiumSection = React.forwardRef<
  HTMLElement,
  PremiumSectionProps
>(({ className, containerClassName, children, ...props }, ref) => {
  return (
    <section
      ref={ref}
      className={cn(
        'relative border-t border-[#232a26] bg-[#0e1110] px-4 py-20 md:py-24',
        className,
      )}
      {...props}
    >
      <SectionContainer className={cn('relative', containerClassName)}>
        {children}
      </SectionContainer>
    </section>
  )
})

PremiumSection.displayName = 'PremiumSection'
